import Mock from './mock';

import './db/users';
import './db/notification';
import './db/calendarEvents';
import './db/roomBooking';
import './db/chat';

Mock.onAny().passThrough();
